document.addEventListener("DOMContentLoaded", () => {
  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(
    document.querySelectorAll(".navbar-burger"),
    0
  );

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach((el) => {
      el.addEventListener("click", () => {
        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        let body = document.getElementsByTagName("body")[0];
        let html = document.getElementsByTagName("html")[0];

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle("is-active");
        $target.classList.toggle("is-active");

        body.classList.toggle("is-active");
        html.classList.toggle("is-active");
      });
    });
  }

  const searchBarOpen = document.getElementById("openSearchBar");
  const barSearch = document.getElementById("searchBar");
  const searchBarInput = document.getElementById("inputSearchBar");
  const submitSearch = document.getElementById("searchsubmit");

  let searchBarIsOpen = false;

  searchBarOpen.addEventListener("click", (e) => {
    e.preventDefault();
    barSearch.classList.add("is-active");
    setTimeout(function () {
      barSearch.classList.add("is-fadein");
      searchBarIsOpen = true;
    }, 150);
    searchBarInput.focus();
  });

  searchBarInput.addEventListener("keypress", function (event) {
    if (event.keyCode == 13) {
      submitSearch.click();
    }
  });

  document.body.addEventListener("click", function (e) {
    if (searchBarIsOpen) {
      if (e.target == searchBarInput || e.target == submitSearch) {
        searchBarIsOpen = true;
      } else {
        setTimeout(function () {
          barSearch.classList.remove("is-fadein");
        }, 150);
        barSearch.classList.remove("is-active");
        searchBarIsOpen = false;
      }
    }
  });
});

const menu = document.getElementById("navsticky");
const top = menu.offsetTop;
const navbar = document.getElementById("navigation");

function scroll() {
  var y = document["documentElement" || "body"].scrollTop;

  if (y >= top) navbar.classList.add("scrolling");
  else navbar.classList.remove("scrolling");
}

window.addEventListener("scroll", scroll);

const scrollToTop = document.getElementById("scrolltop");

scrollToTop.addEventListener("click", (e) => {
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" });
});
